import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import ServiceWrapper from './serviceWrapper';
import { Dropdown } from 'react-dropdown-now';
import 'react-dropdown-now/style.css';
import styles from '../styles/configuration.module.scss';

function EquipmentConfig({ service, changeConfigurations, intialConfigs }) {
    const { t } = useTranslation('configuration');

    const dataSwitches = [
        {
            value: 'cisco',
            label: '2x Cisco Nexus',
        },
        {
            value: 'other',
            label: '2x Other L3 Switches',
        },
        {
            value: 'stacked',
            label: 'Stacked L3 Switch',
        }
    ];

    const managementSwitches = [
        {
            value: 'cisco',
            label: '2x Cisco Catalyst',
            text: '2x Cisco Catalyst'
        },
        {
            value: 'other',
            label: '2x Other Switches',
            text: '2x Other Switches'
        },
        {
            value: 'stacked',
            label: 'Stacked Switch',
            text: 'Stacked Switch'
        }
    ];

    const [options, setOptions] = useState(intialConfigs);
    const [isMount, setIsMount] = useState(false);

    useEffect(() => {
        if (isMount) {
            changeConfigurations({ ...options });
        }
    }, [options]);

    useEffect(() => {
        setIsMount(true);
    }, []);

    return (
        <ServiceWrapper service={service}>
            <label>
                <input checked={options.dedicated} style={{ marginLeft: '0px' }} className='pointer' onChange={() => setOptions(prevState => ({ ...prevState, dedicated: !prevState.dedicated }))} type="checkbox" />
                <p className={'pointer ' + styles.content}>
                    { t('equipment.dedicated') }
                </p>
            </label>
            <br />
            { options.dedicated ? <div className={styles.options}>
                <div className={styles['config-wrapper']}>
                    <p className={'pointer ' + styles.content}>
                        {t('equipment.data')}
                    </p>
                    <Dropdown
                        options={dataSwitches}
                        onChange={(option) => setOptions(prevState => ({ ...prevState, data: option.value }))}
                        value={options.data}
                        className={styles['dropdown-size']}
                    />
                </div>
                <div className={styles['config-wrapper']}>
                    <p className={'pointer ' + styles.content}>
                        { t('equipment.management') }
                    </p>
                    <Dropdown
                        options={managementSwitches}
                        onChange={(e) => setOptions(prevState => ({ ...prevState, management: e.value }))}
                        value={options.management}
                        className={styles['dropdown-size']}
                    />
                </div>
            </div> : <p>{t('equipment.description')}</p> }
            <style jsx>{`
                select {
                    width: 70px;
                }
            `}</style>
        </ServiceWrapper>
    )
};

export default memo(EquipmentConfig);
